import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

export * from './helpers/guessStringType'
export * from './helpers/guessColumnType'
export * from './helpers/isValidFileType'
export * from './helpers/uniqueTableName'

/**
 * Constants for import steps
 */
export const IMPORT_STEPS = {
  SELECT_FILE: 'SELECT_FILE',
  PREVIEW_DATA: 'PREVIEW_DATA',
  PROCESS_DATA: 'PROCESS_DATA',
  COMPLETE: 'COMPLETE',
} as const

/**
 * Constants for import processing states
 */
export const IMPORT_PROCESSING_STATE = {
  WAITING: 'Waiting...',
  PROCESSING: 'In Progress...',
  COMPLETE: 'Completed',
  ERROR: 'Error',
}

export type ImportStep = (typeof IMPORT_STEPS)[keyof typeof IMPORT_STEPS] | null
export type ImportProcessingState = (typeof IMPORT_PROCESSING_STATE)[keyof typeof IMPORT_PROCESSING_STATE]

/**
 * Interface representing a column header
 */
export interface ColumnHeader {
  id: string
  originalIndex: number
  title: string
  isHidden: boolean
  columnType: ColumnTypes
}

/**
 * Interface representing an import item
 */
export interface ImportItem {
  index: number
  name: string
  isIgnoreFirstRow: boolean
  excludeColumnHeaders: ColumnHeader[]
  columnHeaders: ColumnHeader[]
  data: string[][]
  disabled?: boolean
}

/**
 * Interface representing the state of the import process
 */
export interface ImportState {
  dbId?: string
  step: ImportStep
  type: 'import' | 'append'
  fileName?: string
  fileExtension?: string
  fileType: 'csv' | 'excel' | null
  activeSheet: number
  items: ImportItem[]
  state: {
    [key: string]: ImportProcessingState
  }
}
